export default __webpack_public_path__ + "media/images/Strawberry-5b53ddc0b54f1bdd98ccb1cb9649203c.png";